import { Grid2, Slide, Switch, Tab, Typography } from "@mui/material";
import React from "react";
import CommonButton from "../../../../component/Button";
import ToogleButton from "../../../../component/ToogleButton";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  TabPanelView,
} from "../../../common-components/StyledComponents";

import { TabContext } from "@mui/lab";
import { useFormikContext } from "formik";
import ReviewPendingIco from "../../../../assets/icons/ReviewPendingIco";
import VerifiedIco from "../../../../assets/icons/VerifiedIco";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomTooltipField, TabCardSection } from "../../../jobs/style";
import Score from "./Score";

export default function SowCandidate({
  alignment,
  isLoading,
  JobJobEditData,
  jobData,
  handleSearchStringClick,
  buttonLoader,
  handleScrollToError,
  handleSubmitJob,
  iconVisible,
  setIconVisible,
  fetchJobsList,
  fixLoader,
  cardValue,
  handleToogleChange,
  ToogleData,
  cardData,
  accordionDataView,
  jobId,
  handleCardChange,
  handleMarkAsVerified,
  candidateDisabled,
  handlePiriorityChange,
  bounds,
  handleReviewInfo,
  validInsights,
  filterInferredSkill,
  filterFieldLevelData,
  jobValue,
}) {
  const { values, validateForm, setTouched, errors } = useFormikContext();

  return (
    <CustomDiv>
      <Grid2 container spacing={2}>
        <CommonGrid2
          size={{ xs: 12, md: 4, sm: 12 }}
          item
          alignItems={"baseline"}
          display={"flex"}
        >
          {isLoading ? (
            <HandleSkeletion height={50} width={"100%"} />
          ) : (
            <CustomDiv>
              <Typography variant="h3">
                {jobData?.job_details?.job_title}
              </Typography>
              <Typography variant="h6">
                {jobData?.job_details?.company_name}
                {jobData?.job_details?.req_id &&
                  " - " + jobData?.job_details?.req_id}
              </Typography>
              <Typography variant="p">
                <b>Job ID :</b> {jobData?.job_details?.job_order_no}
              </Typography>
            </CustomDiv>
          )}
        </CommonGrid2>

        <CommonGrid2
          item
          size={{ xs: 12, md: 8, sm: 12 }}
          gap="10px"
          display="flex"
          justifyContent={"end"}
          alignItems={"end"}
          flexDirection={"column"}
          height={"fit-content"}
        >
          <CommonGrid2
            display={"flex"}
            flexDirection={"row"}
            size="12"
            gap={"1rem"}
            flexWrap={"wrap"}
            width={"100%"}
            justifyContent="end"
          >
            {jobData?.job_details?.is_scored && (
              <CommonButton
                variant="outlined"
                color="#344054"
                border="#D0D5DD"
                fontWeight="600"
                value="Generate Search Strings"
                padding={"10px 20px"}
                onClick={handleSearchStringClick}
                disabled={candidateDisabled}
              />
            )}

            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              padding={"10px 20px"}
              value="Share"
              disabled={true || candidateDisabled}
            />
            {alignment === "View" &&
              (jobData?.job_details?.is_scored
                ? jobData?.show_rescore
                : jobData?.job_details?.is_scored) && (
                <CommonButton
                  variant="contained"
                  color="white"
                  background="#7F56D9"
                  fontWeight="600"
                  padding={"10px 20px"}
                  value={"Re-Score"}
                  // type="submit"
                  disabled={
                    candidateDisabled || isLoading || buttonLoader.disabled
                  }
                  loading={buttonLoader.rescoreLoading}
                  onClick={async () => {
                    setTimeout(async () => {
                      let data = await validateForm();
                      handleScrollToError(data);
                      if (Object.keys(data).length === 0) {
                        handleSubmitJob(values, true);
                      }
                    }, 0);
                  }}
                />
              )}

            {alignment === "View" && (
              <CommonButton
                variant="contained"
                color="white"
                background="#7F56D9"
                fontWeight="600"
                padding={"10px 20px"}
                value={!jobData?.job_details?.is_scored ? "Score" : "Activate"}
                type="submit"
                disabled={
                  candidateDisabled || buttonLoader.disabled || isLoading
                }
                loading={buttonLoader.activateLoading}
                onClick={async () => {
                  await new Promise((resolve) => {
                    setTimeout(resolve, 0);
                  });

                  const data = await validateForm();
                  handleScrollToError(data);
                }}
              />
            )}
            {alignment === "Edit" && (
              <CommonButton
                value="Submit"
                padding="5px 2rem"
                fontWeight="600"
                disabled={
                  candidateDisabled || buttonLoader.disabled || isLoading
                }
                loading={buttonLoader.submitLoading}
                onClick={async () => {
                  await new Promise((resolve) => {
                    setTimeout(resolve, 0);
                  });

                  const data = await validateForm();
                  handleScrollToError(data);

                  if (Object.keys(data).length === 0) {
                    handleSubmitJob(values, "submit");
                  }
                }}
              />
            )}

            <ToogleButton
              ToogleData={ToogleData}
              handleChange={handleToogleChange}
              alignment={alignment}
              border={"1px solid #D0D5DD"}
              borderRadius={"8px"}
              activeColor={"#344054"}
              color={"#344054"}
              activeBackgroundColor="#F9FAFB"
              backgroundColor="#FFFF"
              disabled={candidateDisabled || isLoading}
            />
          </CommonGrid2>
          <CommonGrid2
            display={"flex"}
            gap={"1rem"}
            alignItems={"end"}
            flexWrap={"wrap"}
          >
            <CommonGrid2 display={"flex"} gap={"5px"} alignItems={"center"}>
              <Typography variant="body4">Set as High Priority </Typography>
              <Switch
                checked={values.priority_type === "high_priority"}
                onChange={(event) => handlePiriorityChange(event)}
              />
            </CommonGrid2>
            <CommonGrid2 display={"flex"} gap={"5px"} alignItems={"center"}>
              <Typography variant="body4">Vision Assist</Typography>
              <Switch
                checked={iconVisible}
                onChange={(event) => setIconVisible(event.target.checked)}
              />
            </CommonGrid2>
          </CommonGrid2>
        </CommonGrid2>
      </Grid2>
      {((alignment === "View" &&
        jobData?.job_details?.insights &&
        Object.keys(jobData?.job_details?.insights).length !== 0) ||
        (alignment === "Edit" && JobJobEditData.is_scored)) && (
        <Score
          jobData={alignment === "View" ? jobData?.job_details : JobJobEditData}
          isLoading={fixLoader ? false : isLoading}
          fetchJobsList={fetchJobsList}
          job_id={jobId}
          fixLoader={fixLoader}
          toolTipOpen={fixLoader ? false : alignment === "View" ? true : false}
          handleReviewInfo={handleReviewInfo}
          mandatoryDisabled={
            alignment === "View"
              ? !(
                  jobData?.job_details?.job_title &&
                  jobData?.job_details?.company_name
                )
              : !(jobValue?.job_title && jobValue?.company_name)
          }
          anomalyDisabled={
            jobData?.job_details?.insights?.insights?.length !== 0 &&
            validInsights?.length !== 0
          }
          filterInferredSkill={filterInferredSkill?.length !== 0}
          filterFieldLevelData={filterFieldLevelData?.length !== 0}
          hideCondition={false}
        />
      )}

      <TabContext value={cardValue.value}>
        <CommonGrid2 container spacing={2} alignItems="center" marginTop={2.5}>
          <TabCardSection
            breakpoint={bounds.width < 900 ? "2000" : "1400"}
            onChange={handleCardChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="visible arrows tabs example"
          >
            {cardData.map((item, index) => (
              <Tab
                value={index}
                label={
                  <Grid2
                    item
                    key={index}
                    size={12}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    height={"100%"}
                    gap={"1rem"}
                  >
                    {isLoading ? (
                      <HandleSkeletion
                        width="50px"
                        height="50px"
                        marginRight={"1rem"}
                        transform="scale(1)"
                        borderRadius="50px"
                      />
                    ) : (
                      item?.icon
                    )}
                    {isLoading ? (
                      <HandleSkeletion
                        width="100%"
                        height="30px"
                        transform="scale(1)"
                      />
                    ) : (
                      <CommonGrid2>
                        <Typography
                          fontSize={"15px"}
                          fontWeight={600}
                          color={"#101828"}
                        >
                          {item.name}
                        </Typography>
                        <Typography
                          variant="caption"
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          fontSize={"12px"}
                          fontWeight={500}
                          color={"#475467"}
                          marginTop={"8px"}
                        >
                          {item.status === "Review Pending" ? (
                            <ReviewPendingIco size={22} />
                          ) : (
                            <VerifiedIco />
                          )}
                          &nbsp;&nbsp;&nbsp;
                          {item.status}
                        </Typography>
                      </CommonGrid2>
                    )}
                  </Grid2>
                }
              />
            ))}
          </TabCardSection>
        </CommonGrid2>
        <CommonGrid2 style={{ overflow: "hidden" }}>
          {accordionDataView.map((item, index) => (
            <Slide
              direction={cardValue.value > cardValue.prev ? "right" : "left"}
              in={cardValue.value === index}
              timeout={500}
              mountOnEnter
              unmountOnExit
            >
              <TabPanelView value={index} padding="0rem 0px 0px">
                <CommonGrid2 size={12} padding={"1rem 0rem"}>
                  <CommonGrid2
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    padding={"1rem 0rem"}
                  >
                    {isLoading ? (
                      <HandleSkeletion height={50} width={"100px"} />
                    ) : (
                      <Typography variant="h3" margin={"15px 0px"}>
                        {item.title}
                      </Typography>
                    )}
                    {isLoading ? (
                      <HandleSkeletion height={50} width={"100px"} />
                    ) : (
                      alignment === "Edit" && (
                        <CustomDiv position="relative">
                          <CommonButton
                            variant="contained"
                            color="white"
                            background="#7F56D9"
                            fontWeight="600"
                            padding={"10px 20px"}
                            value={"Mark as verified"}
                            disabled={cardData[index].disabled}
                            loading={cardData[index].loading}
                            onClick={() =>
                              handleMarkAsVerified(
                                index,
                                values,
                                validateForm,
                                setTouched
                              )
                            }
                          />
                          {errors.marked_as_verified &&
                            !cardData[index].disabled && (
                              <CustomTooltipField
                                size={7}
                                top="-40px"
                                className="Mui-error"
                              >
                                Kindly verify this section
                              </CustomTooltipField>
                            )}
                        </CustomDiv>
                      )
                    )}
                  </CommonGrid2>
                  {item.component}
                </CommonGrid2>
              </TabPanelView>
            </Slide>
          ))}
        </CommonGrid2>
      </TabContext>
    </CustomDiv>
  );
}
